let MAX_PLAYERS = parseInt(process.env.AMERICAN_DAD_MAX_PLAYERS);
if (isNaN(MAX_PLAYERS) || MAX_PLAYERS <= 0) {
  MAX_PLAYERS = 4;
}
const LOCAL_STORAGE_PREFIX = "com.tbs.american-dad-quiz300";
const LOBBY_TIMEOUT = 300;
const GAME_START_DELAY = 3;
const ROUND_TIMEOUT = 10;
const ROUND_DELAY = 3;
const MAX_SCORE = 10000;
const MAX_QUESTION_SCORE = 1000;
const MAX_QUESTION_SETS = 100;
const GAME_URL =
  process.env.NODE_ENV === "production"
    ? "https://qa.tbs.com/am-dad-game"
    : `${window.location.origin.toString()}`;
// const GAME_URL = "http://dev.weareglow.com/tbs/ad-quiz";
const S3_BASE_URL =
  "https://tbstnt-vendor-glow-americandad-quiz300.s3.amazonaws.com";
const IMAGE_COLLECTABLE_9X16_DIR = "/images/collectables/9x16";
const IMAGE_COLLECTABLE_16X9_DIR = "/images/collectables/16x9";
const IMAGE_QUESION_DIR = "/images/question-images";

export {
  LOCAL_STORAGE_PREFIX,
  MAX_PLAYERS,
  LOBBY_TIMEOUT,
  ROUND_TIMEOUT,
  GAME_START_DELAY,
  ROUND_DELAY,
  MAX_SCORE,
  MAX_QUESTION_SCORE,
  MAX_QUESTION_SETS,
  GAME_URL,
  S3_BASE_URL,
  IMAGE_COLLECTABLE_9X16_DIR,
  IMAGE_COLLECTABLE_16X9_DIR,
  IMAGE_QUESION_DIR
};
